"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourierImplementation = void 0;
/**
 * The implementation of the courier endpoint request
 */
var CourierImplementation = /** @class */ (function () {
    function CourierImplementation(request) {
        this.request = request;
    }
    /**
     * Return a list of couriers activated at your AfterShip account
     */
    CourierImplementation.prototype.listCouriers = function () {
        return this.request.makeRequest({ method: 'GET', url: '/couriers' });
    };
    /**
     * Return a list of all couriers
     */
    CourierImplementation.prototype.listAllCouriers = function () {
        return this.request.makeRequest({ method: 'GET', url: '/couriers/all' });
    };
    /**
     * Return a list of matched couriers based on tracking number format and selected couriers or a list of couriers
     * @param data data
     */
    CourierImplementation.prototype.detectCouriers = function (data) {
        return this.request.makeRequest({ method: 'POST', url: '/couriers/detect' }, data);
    };
    return CourierImplementation;
}());
exports.CourierImplementation = CourierImplementation;
